import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type MagentoProduct = {
  sku?: string;
  name?: string;
  price?: number;
  quantity?: number;
  [key: string]: any;
};

type ProductsState = {
  items: MagentoProduct[];
  lastSyncedAt: string | null;
};

const initialState: ProductsState = {
  items: [],
  lastSyncedAt: null,
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProducts(state, action: PayloadAction<MagentoProduct[]>) {
      state.items = action.payload;
      state.lastSyncedAt = new Date().toISOString();
    },
    clearProducts(state) {
      state.items = [];
      state.lastSyncedAt = null;
    },
  },
});

export const { setProducts, clearProducts } = productsSlice.actions;
export default productsSlice.reducer;
